/**
 * Created by mac on 12/21/20
 */

const FamiliesHelper = {
    ShapeCell: [
        { x: 0, y: 0 }
    ],

    ShapeSquare: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 1 }
    ],

    Shape1x2: [
        { x: 0, y: 0, passable: true },
        { x: 0, y: 1, passable: true }
    ],

    Shape1x2Horizontal: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0, passable: true }
    ],

    ShapeSquarePassableLeftAnchor: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0, passable: true },
        { x: 0, y: 1, passable: true },
        { x: 1, y: 1, passable: true }
    ],

    Shape2x3Vertical: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0, passable: true },
        { x: 0, y: 1, passable: true },
        { x: 1, y: 1, passable: true },
        { x: 0, y: 2, passable: true },
        { x: 1, y: 2, passable: true }
    ],

    Shape1x3Vertical: [
        { x: 0, y: 0, passable: true },
        { x: 0, y: 1, passable: true },
        { x: 0, y: 2, passable: true }
    ],

    Shape1x3Horizontal: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0, passable: true },
        { x: 2, y: 0, passable: true }
    ],

    Shape4x3Passable: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0, passable: true },
        { x: 2, y: 0, passable: true },
        { x: 3, y: 0, passable: true },
        { x: 0, y: 1, passable: true },
        { x: 1, y: 1, passable: true },
        { x: 2, y: 1, passable: true },
        { x: 3, y: 1, passable: true }
    ],

    Shape3x3: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 1 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 2 },
        { x: 2, y: 2 }
    ],

    Shape1x4Horizontal: [
        { y: 0, x: 0, passable: true },
        { y: 0, x: 1, passable: true },
        { y: 0, x: 2, passable: true },
        { y: 0, x: 3, passable: true }
    ],

    Shape1x4Vertical: [
        { y: 0, x: 0, passable: true },
        { y: 1, x: 0, passable: true },
        { y: 2, x: 0, passable: true },
        { y: 3, x: 0, passable: true }
    ],

    Shape1x5Horizontal: [
        { y: 0, x: 0, passable: true },
        { y: 0, x: 1, passable: true },
        { y: 0, x: 2, passable: true },
        { y: 0, x: 3, passable: true },
        { y: 0, x: 4, passable: true }
    ],

    Shape1x6: [
        { y: 0, x: 0, passable: true },
        { y: 1, x: 0, passable: true },
        { y: 2, x: 0, passable: true },
        { y: 3, x: 0, passable: true },
        { y: 4, x: 0, passable: true },
        { y: 5, x: 0, passable: true }
    ],

    ShapeIslandDecoration: [
        { x: -1, y: -3 }, { x: 0, y: -3 }, { x: 1, y: -3 }, { x: 2, y: -3 },
        { x: -3, y: -2 }, { x: -2, y: -2 }, { x: -1, y: -2 }, { x: 0, y: -2 }, { x: 1, y: -2 }, { x: 2, y: -2 },
        { x: -3, y: -1 }, { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 },

        { x: -3, y: 0 }, { x: -2, y: 0 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 }, { x: 3, y: 0 },
        { x: -3, y: 1 }, { x: -2, y: 1 }, { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 }, { x: 3, y: 1 },

        { x: -1, y: 2 }, { x: 0, y: 2 }, { x: 1, y: 2 }, { x: 2, y: 2 },
        { x: -1, y: 3 }, { x: 0, y: 3 }, { x: 1, y: 3 }, { x: 2, y: 3 }
    ],

    DeprecatedShapes: {
        Shape3x1AnchorRight: [
            { x: 0, y: 0, passable: true },
            { x: -1, y: 0, passable: true },
            { x: -2, y: 0, passable: true }
        ],

        ShapeSquarePassableRightAnchor: [
            { x: 0, y: -1, passable: true },
            { x: -1, y: 0, passable: true },
            { x: 0, y: 0, passable: true },
            { x: -1, y: -1, passable: true }
        ],

        ShapeSquarePassableTopAnchor: [
            { x: 0, y: 0, passable: true },
            { x: -1, y: 0, passable: true },
            { x: -1, y: 1, passable: true },
            { x: 0, y: 1, passable: true }
        ],

        Shape2x3PassableStrip: [
            { x: 0, y: -1 },
            { x: 1, y: -1 },
            { x: 0, y: 0, passable: true },
            { x: 1, y: 0, passable: true },
            { x: 0, y: 1 },
            { x: 1, y: 1 }
        ],

        Shape2x3Passable: [
            { x: 0, y: 0, passable: true },
            { x: -1, y: 0, passable: true },
            { x: -2, y: 0, passable: true },
            { x: 0, y: 1, passable: true },
            { x: -1, y: 1, passable: true },
            { x: -2, y: 1, passable: true }
        ],

        ShapeXArc: [
            { y: 0, x: 0 },
            { y: 0, x: -1, passable: true },
            { y: 0, x: -2 },
            { y: -1, x: 0 },
            { y: -1, x: -1, passable: true },
            { y: -1, x: -2 }
        ]
    },

    Drop: {
        Default: 0,
        Parallel: 1,
        Open: 2
    },

    ResourceFamily: function (total, code, options) {
        const expPrizes = [0, 1, 2, 3, 5, 10, 15, 25, 150, 300, 500, 1000, 3000, 5000, 8000];
        const softPrizes = [0, 0, 1, 2, 3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

        let i;
        options = options || {};

        let collectedStage;
        const createPrizes = [];
        for (i = 0; i < total; i++) {
            if (i === total - 1) {
                createPrizes.push({
                    exp: createPrizes[i - 1].exp * 10,
                    soft: 75
                });
            } else {
                let prize = undefined;
                if (expPrizes[i] || softPrizes[i]) {
                    prize = {};
                    if (expPrizes[i]) {
                        prize.exp = expPrizes[i];
                    }
                    if (softPrizes[i]) {
                        prize.soft = softPrizes[i];
                    }
                }
                createPrizes.push(prize);
            }
        }

        const buildable = ["0 seconds", "0 seconds", "40 seconds", "1 minute", "5 minute", "15 minute", "2 hour", "4 hour", "8 hour", "12 hour", "14 hour", "16 hour", "18 hour", "20 hour", "22 hour"];
        if (code === "wood") {
            buildable.splice(2, 0, "15 seconds");
        }

        buildable.splice(total - 1);
        while (buildable.length < total - 1) {
            buildable.push(buildable[buildable.length - 1]);
        }

        const units = buildable.map((value, stage) => {
            const res = {
                buildable: value,
                createPrize: createPrizes[stage],
                price: (options.basicPrice || 13) * Math.pow(3, stage)
            };

            if (stage === buildable.length - 1) {
                res.unmergeable = true;
                res.resourceCollectible = true;
                res.pulsing = true;
                res.draggable = true;
                collectedStage = stage;
            }
            return res;
        });

        units.push({
            lazy: options.lazy,
            price: (options.basicPrice || 13) * Math.pow(3, 8),
            unmergeable: true,
            temporary: true,
            multicell: FamiliesHelper.ShapeSquare,
            important: true,
            movable: false,
            pointOfInterest: true,
            upgradable: {
                stages: 5,
                level: 0,
                collectedStage,
                moveToNextStage: true
            },
            unsuitableForGift: true
        });

        units.push({
            lazy: options.lazy,
            price: (options.basicPrice || 13) * Math.pow(3, 9),
            unmergeable: true,
            multicell: FamiliesHelper.ShapeSquare,
            upgradable: {
                stages: 5,
                stagesByLevel: 2,
                level: 1,
                collectedStage
            },
            fruit: {
                duration: "24 hour",
                exp: 50,
                prize: [{
                    amount: [5, 8],
                    units: [
                        { code: "sacks", stage: 0 }, { code: "sacks", stage: 1 }, { code: "worker", stage: 0 },
                        { code: "worker", stage: 1 }, { code, stage: 0 }, { code: "wands", stage: 0 },
                        { code: "coins", stage: 0 }, { code: "coins", stage: 1 }
                    ]
                }],
                localPush: PUSHES.CASTLE_PRIZE
            },
            important: true,
            buildable: "24 hour",
            createPrize: createPrizes[total - 1],
            unsuitableForGift: true
        });

        return {
            type: "resource",
            expeditions: options && options.expeditions,
            images: options && options.images,
            units
        };
    },

    FruitFamily: function (options) {
        const mining = {
            time: "15 seconds",
            exp: 5,
            energy: 5
        };

        return {
            type: "fruit",
            expeditions: options && options.expeditions,
            images: options && options.images,
            units: [
                { price: 1 },
                { price: 4, createPrize: { exp: 1, soft: 1 } },
                { price: 12, createPrize: { exp: 2, soft: 2 } },
                {
                    price: 36,
                    fruit: {
                        duration: options.duration,
                        prize: [{
                            amount: [4, 6],
                            units: [{ code: options.code, stage: 4 }]
                        }],
                        localPush: PUSHES.FRUIT_RIPE
                    },
                    breakable: { nextUnit: { code: options.code, stage: 5 } },
                    unmergeable: true,
                    createPrize: { exp: 3, soft: 3 }
                },
                {
                    price: 3,
                    pulsing: true,
                    collectible: {
                        harvested: true
                    },
                    value: 1,
                    unmergeable: true
                },
                {
                    price: 5,
                    mineable: { tasks: [mining] } 
                }
            ]
        };
    },

    FeedFruitFamily: function (options) {
        const mining = {
            time: options.time || "15 seconds",
            exp: 5,
            energy: 5
        };

        return {
            type: options.type,
            expeditions: options && options.expeditions,
            images: options && options.images,
            units: [
                {},
                { createPrize: { exp: 1 } },
                { createPrize: { exp: 2 } },
                {
                    fruit: {
                        duration: options.duration,
                        prize: options.prize,
                        localPush: PUSHES.FRUIT_RIPE
                    },
                    breakable: { nextUnit: { code: options.code, stage: 5 } },
                    unmergeable: true,
                    createPrize: { exp: 3 },
                    readyFoodSource: true
                },
                {
                    collectible: true,
                    feedableTarget: true,
                    value: 1,
                    unmergeable: true,
                    pulsing: true,
                    draggable: true
                },
                {
                    mineable: { tasks: [mining] },
                    mined: true 
                }
            ]
        };
    },

    CustomFamily: function (total, type, options) {
        options = options || {};

        const createExp = [0, 5, 10, 15, 25];
        const units = [];
        for (let i = 0; i < total; i++) {
            const res = {};

            if (createExp[i]) {
                res.createPrize = {
                    exp: createExp[i]
                };
            }

            res.price = options.price[i];

            if (options.shine && i > 0) {
                res.shine = true;
            }

            if (options.draggable) {
                res.draggable = true;
            }

            if (options.instantWorker && i === total - 1) {
                res.draggable = true;
                res.instantWorker = true;
            }

            if (options.info) {
                res.info = options.info;
            }

            units.push(res);
        }

        return {
            type,
            expeditions: options.expeditions,
            extraBundles: options.extraBundles,
            images: options.images,
            units
        };
    },

    ChestFamily: function (resource, options) {
        options = options || {};

        const prizes = ChestListPrize[resource];
        const units = [];
        let price = options.price ? options.price : undefined;

        if (options.resourceChest) {
            price = [3, 35, 52];
        }

        for (let i = 0; i < prizes.length; i++) {
            const unit = {
                price: price ? price[i] : undefined,
                chest: true,
                lockable: true,
                animation: options.animation === undefined ? true : options.animation,
                resourceChest: options.resourceChest,
                skipCheckScreen: options.skipCheckScreen,
                radius: options.radius
            };

            if (ChestCreatePrize[resource]) {
                unit.createPrize = ChestCreatePrize[resource][i];
            } else if (options.resourceChest) {
                unit.createPrize = ChestCreatePrize.resourcechest[i];
            }

            if (ChestEnergyPrize[resource]) {
                unit.energyPrize = ChestEnergyPrize[resource][i];
            } else if (options.resourceChest) {
                unit.energyPrize = ChestEnergyPrize.resourcechest[i];
            }
            units.push(unit);
        }

        return {
            type: "chest",
            resource,
            expeditions: options.expeditions,
            images: options.images,
            extraBundles: options.extraBundles,
            units
        };
    },

    ValuableFamily: function (id, options) {
        options = options || {};
        return {
            type: "valuables",
            id,
            expeditions: options.expeditions,
            images: options.images,
            extraBundles: options.extraBundles,
            units: options.amounts.map((value, stage) => {
                const res = {
                    value,
                    price: value
                };

                if (options.exp && options.exp[stage]) {
                    res.createPrize = { exp: options.exp[stage] };
                }

                if (options.collectible && value !== 0) {
                    res.collectible = options.collectible;
                }

                if (options.pulsing) {
                    res.pulsing = true;
                }

                if (options.unmergeable) {
                    res.unmergeable = true;
                }

                if (options.shineFrom && stage >= options.shineFrom) {
                    res.shine = true;
                }

                if (options.draggable) {
                    res.draggable = true;
                }

                if (options.unitsLibrary) {
                    res.unitsLibrary = true;
                }

                return res;
            })
        };
    },

    GeneratorFamily: function (resource) {
        const mineStages = 7;
        const tasks = [];
        for (let j = 0; j < mineStages; j++) {
            const isLast = j === mineStages - 1;
            tasks.push({
                time: isLast ? "3 hours" : "0 seconds",
                exp: isLast ? 100 : 30,
                energy: isLast ? 35 : 10
            });
        }

        return {
            type: "merge3generator",
            resource,
            units: [
                {
                    price: 1000,
                    unmergeable: true,
                    mineable: { tasks, missionReward: [{ missionType: Mission.TYPE_HUNGRY_GAMES, amount: 0 }] },
                    multicell: FamiliesHelper.ShapeSquare,
                    merge3Generator: {},
                    important: true,
                    pointOfInterest: true,
                    lazy: true
                }
            ]
        };
    },

    MonsterFamily: function (monster, options) {
        const exp = [3, 5, 10, 15, 20, 25];
        const wands = [5, 10, 15, 20, 25, 30];
        const bonusWands = wands.map((val) => val * 5);

        const attackStages = [2, 4, 6];
        const levels = [];

        for (let stage = 0; stage < 3; stage++) {
            const attacks = attackStages[stage];
            const level = [];
            for (let i = 0; i < attacks; i++) {
                level.push({
                    exp: exp[i],
                    wands: wands[i],
                    bonusWands: bonusWands[i]
                });
            }
            levels[stage] = level;
        }

        return {
            type: "monster",
            units: [
                {
                    unmergeable: true,
                    mineable: { tasks: levels[0] },
                    movable: false,
                    monster,
                    missionType: options.mission,
                    manualPrizes: true,
                    lazy: options.lazy
                },
                {
                    unmergeable: true,
                    mineable: { tasks: levels[1] },
                    movable: false,
                    monster,
                    missionType: options.mission,
                    manualPrizes: true,
                    lazy: options.lazy
                },
                {
                    unmergeable: true,
                    mineable: { tasks: levels[2] },
                    movable: false,
                    monster,
                    multicell: FamiliesHelper.ShapeSquare,
                    missionType: options.mission,
                    manualPrizes: true,
                    lazy: options.lazy
                }
            ]
        };
    },

    SourceFamily: function (resource, addEnergy) {
        const mining = {
            stump: [
                {
                    time: "0 second",
                    exp: 5,
                    energy: 3 + addEnergy
                }, {
                    time: "30 seconds",
                    exp: 20,
                    energy: 5 + addEnergy
                }
            ],
            sapling: [
                {
                    time: "0 second",
                    exp: 5,
                    energy: 3 + addEnergy
                }, {
                    time: "0 second",
                    exp: 20,
                    energy: 5 + addEnergy
                }, {
                    time: "0 second",
                    exp: 25,
                    energy: 10 + addEnergy
                }, {
                    time: "45 seconds",
                    exp: 30,
                    energy: 15 + addEnergy
                }
            ],
            tree: [
                {
                    time: "0 second",
                    exp: 5,
                    energy: 5 + addEnergy
                }, {
                    time: "0 second",
                    exp: 20,
                    energy: 10 + addEnergy
                }, {
                    time: "0 second",
                    exp: 25,
                    energy: 15 + addEnergy
                }, {
                    time: "0 second",
                    exp: 30,
                    energy: 20 + addEnergy
                }, {
                    time: "0 second",
                    exp: 35,
                    energy: 25 + addEnergy
                }, {
                    time: "1 minute",
                    exp: 40,
                    energy: 30 + addEnergy
                }
            ]
        };

        const missionRewards = {
            stage_1: [
                {
                    missionType: Mission.TYPE_ISLAND_DECORATION,
                    amount: 5
                }, {
                    missionType: Mission.TYPE_TREASURE_SEARCH,
                    amount: 1
                }, {
                    missionType: Mission.TYPE_HUNGRY_GAMES,
                    amount: 0
                }
            ],

            stage_3: [
                {
                    missionType: Mission.TYPE_ISLAND_DECORATION,
                    amount: 15
                }, {
                    missionType: Mission.TYPE_TREASURE_SEARCH,
                    amount: 3
                }, {
                    missionType: Mission.TYPE_HUNGRY_GAMES,
                    amount: 0
                }
            ],

            stage_5: [
                {
                    missionType: Mission.TYPE_ISLAND_DECORATION,
                    amount: 45
                }, {
                    missionType: Mission.TYPE_TREASURE_SEARCH,
                    amount: 7
                }, {
                    missionType: Mission.TYPE_SPACE_RACE,
                    amount: 1
                }, {
                    missionType: Mission.TYPE_HUNGRY_GAMES,
                    amount: 0
                }
            ]
        };

        return {
            type: "source",
            resource,
            units: [
                { source: true, price: 7 },
                {
                    source: true, price: 21, mineable: { tasks: mining.stump, missionReward: missionRewards.stage_1 }, unmergeable: true, createPrize: { exp: 1, soft: 1 }
                },
                { source: true, price: 63 },
                {
                    source: true, price: 189, mineable: { tasks: mining.sapling, missionReward: missionRewards.stage_3 }, unmergeable: true, createPrize: { exp: 5, soft: 2 }
                },
                { source: true, price: 567 },
                {
                    source: true, price: 1701, mineable: { tasks: mining.tree, missionReward: missionRewards.stage_5 }, unmergeable: true, createPrize: { exp: 10, soft: 5 }
                }
            ]
        };
    },

    HeroFamily: function (total) {
        const createPrizes = [undefined, { exp: 1, soft: 1 }, { exp: 2, soft: 1 }, { exp: 3, soft: 1 }, { exp: 5, soft: 2 },
            { exp: 10, soft: 3 }, { exp: 25, soft: 5 }, { exp: 40, soft: 5 }, { exp: 50, soft: 5 }, { exp: 70, soft: 7 },
            { exp: 100, soft: 7 }, { exp: 120, soft: 8 }, { exp: 150, soft: 10 }];
        const price = [9, 25];

        const units = cleverapps.arrayFill(total).map((value, index) => {
            const unit = {
                price: price[index],
                heroitem: true
            };

            if (index === total - 1) {
                unit.customer = {
                    viewType: "ordersWindow"
                };
                unit.unmergeable = true;
                unit.unsuitableForGift = true;
            }

            return unit;
        });

        for (let i = 0; i < units.length - 1; i++) {
            units[i].createPrize = createPrizes[i];
        }

        return {
            type: "hero",
            units
        };
    },

    MagicPlantFamily: function (options) {
        const expPrizes = [0, 1, 2, 3, 5, 10, 15, 25, 150];
        const softPrizes = [0, 0, 1, 2, 3, 5, 10, 15, 20];

        const units = [];

        for (let i = 0; i < options.total; ++i) {
            const res = {};

            res.price = Math.pow(3, i);
            if (expPrizes[i] || softPrizes[i]) {
                res.createPrize = {
                    exp: expPrizes[i],
                    soft: softPrizes[i]
                };
            }

            if (i === options.total - 1) {
                res.fruit = {
                    duration: options.timeout,
                    exp: 10,
                    prize: options.prize,
                    localPush: PUSHES.MAGIC_PLANT_READY
                };
                res.breakable = {
                    limit: 10,
                    nextUnit: { code: options.code, stage: 9 }
                };

                res.unmergeable = true;
            }

            if (i > 4) {
                res.shine = true;
            }

            units.push(res);
        }
        units.push({
            mineable: {
                tasks: [{
                    time: "15 seconds",
                    exp: 5,
                    energy: 5
                }]
            }
        });

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images,
            extraBundles: options && options.extraBundles
        };
    },

    ExpeditionMagicPlantFamily: function (options) {
        const expPrizes = [0, 1, 2, 3, 5, 10, 15, 25, 150];
        const softPrizes = [0, 0, 1, 2, 3, 5, 10, 15, 20];

        const units = [];

        for (let i = 0; i < options.total; ++i) {
            const res = {};

            res.price = Math.pow(3, i);
            if (expPrizes[i] || softPrizes[i]) {
                res.createPrize = {
                    exp: expPrizes[i],
                    soft: softPrizes[i]
                };
            }

            if (i === options.total - 1) {
                res.fruit = {
                    duration: options.timeout,
                    exp: 10,
                    prize: options.prize,
                    localPush: PUSHES.MAGIC_PLANT_READY
                };

                res.unmergeable = true;
            }

            if (i > 4) {
                res.shine = true;
            }

            units.push(res);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images,
            extraBundles: options && options.extraBundles
        };
    },

    RubiesPlantFamily: function (total, options) {
        const expPrizes = [0, 50, 200];
        const softPrizes = [0, 10, 30];

        const units = [];

        for (let i = 0; i < total; ++i) {
            const res = {
                fruit: {
                    duration: "6 hours",
                    exp: 10,
                    prize: [{
                        units: [{ code: "rubies", stage: i }]
                    }],
                    localPush: PUSHES.MAGIC_PLANT_READY
                },
                shine: true
            };

            if (expPrizes[i] || softPrizes[i]) {
                res.createPrize = {
                    exp: expPrizes[i],
                    soft: softPrizes[i]
                };
            }

            units.push(res);
        }

        return {
            type: "rubiesplant",
            units,
            expeditions: options && options.expeditions,
            images: options && options.images,
            extraBundles: options && options.extraBundles
        };
    },

    CoinsPlantFamily: function (total, options) {
        const expPrizes = [0, 50, 200];
        const softPrizes = [0, 10, 30];

        const units = [];

        for (let i = 0; i < total; ++i) {
            const res = {
                price: 100 * Math.pow(3, i),
                fruit: {
                    duration: "6 hours",
                    exp: 10,
                    prize: [{
                        units: [{ code: "coins", stage: i + 1 }]
                    }],
                    localPush: PUSHES.MAGIC_PLANT_READY
                },

                shine: true
            };

            if (expPrizes[i] || softPrizes[i]) {
                res.createPrize = {
                    exp: expPrizes[i],
                    soft: softPrizes[i]
                };
            }

            units.push(res);
        }

        return {
            type: "coinsplant",
            units,
            expeditions: options && options.expeditions,
            images: options && options.images,
            extraBundles: options && options.extraBundles
        };
    },

    EnergyPlantFamily: function (total, options) {
        const expPrizes = [0, 50, 200];
        const softPrizes = [0, 10, 30];
        const energy = [3, 10, 35];

        const units = [];

        for (let i = 0; i < total; ++i) {
            const res = {
                price: 100 * Math.pow(3, i),
                fruit: {
                    duration: "6 hours",
                    exp: 10,
                    prize: [{
                        units: [{ resource: "energy", amount: energy[i] }]
                    }],
                    localPush: PUSHES.MAGIC_PLANT_READY
                },
                shine: true
            };

            if (expPrizes[i] || softPrizes[i]) {
                res.createPrize = {
                    exp: expPrizes[i],
                    soft: softPrizes[i]
                };
            }

            units.push(res);
        }

        return {
            type: "energyplant",
            units,
            expeditions: options && options.expeditions,
            images: options && options.images,
            extraBundles: options && options.extraBundles
        };
    },

    ValuableTreeFamily: function (options) {
        const units = [];

        const mining = {
            time: "15 seconds",
            exp: 5,
            energy: 5
        };

        for (let i = 0; i < options.stages.length; ++i) {
            const res = {};

            if (options.stages[i].prize) {
                res.fruit = {
                    duration: options.stages[i].timeout,
                    prize: options.stages[i].prize
                };
            }

            res.price = options.price[i];

            if (options.stages[i].unmergeable) {
                res.unmergeable = true;
            }

            if (options.stages[i].breakable) {
                res.breakable = {
                    limit: options.stages[i].breakable.limit,
                    nextUnit: { code: options.code, stage: 4 }
                };
            }

            units.push(res);
        }
        units.push({ mineable: { tasks: [mining] } });

        return {
            type: options.type,
            units,
            expeditions: options && options.expeditions,
            images: options && options.images,
            extraBundles: options && options.extraBundles
        };
    },

    CoinsCupFamily: function (total, options) {
        const amount = [3, 7, 15];

        const probabilities = [
            [0.6, 0.3, 0.1],
            [0.55, 0.35, 0.1],
            [0.55, 0.35, 0.15]
        ];

        const units = [];
        for (let i = 0; i < total; i++) {
            units.push({
                price: (options && options.price) ? options.price[i] : undefined,
                cup: {
                    amount: amount[i],
                    probabilities: probabilities[i],
                    units: [{ code: "coins", stage: 0 }, { code: "coins", stage: 1 }, { code: "coins", stage: 2 }]
                }
            });
        }

        return {
            type: "coinscup",
            units
        };
    },

    EnergyCupFamily: function (total, options) {
        const amount = options.amount;

        const probabilities = options.probabilities;

        const units = [];
        for (let i = 0; i < total; i++) {
            units.push({
                price: (options && options.price) ? options.price[i] : undefined,
                cup: {
                    amount: amount[i],
                    probabilities: probabilities[i],
                    units: options.rewardsByStages ? options.rewardsByStages[i] : options.rewards,
                    firstRewards: options.firstRewards
                },
                draggable: options.draggable,
                unmergeable: options.unmergeable,
                unitsLibrary: options.unitsLibrary
            });
        }

        return {
            type: "energycup",
            expeditions: options.expeditions,
            units
        };
    },

    FlatMapEnergyCupFamily: function (total, options) {
        const units = [];
        const config = CupsConfig[options.code] || {};
        const stages = total || 1;

        for (let i = 0; i < stages; i++) {
            const stageConfig = config[`stage${i}`] || {};
            const lockDuration = stageConfig.lockDuration || config.lockDuration;
            const lockable = lockDuration ? { duration: lockDuration } : undefined;
            units.push({
                price: stageConfig.price || config.price,
                cup: {
                    amount: stageConfig.amount || config.amount,
                    probabilities: stageConfig.probabilities || config.probabilities,
                    units: CupsConfig.parseRewards(stageConfig.rewards || config.rewards)
                },
                draggable: options.draggable,
                unmergeable: options.unmergeable,
                unitsLibrary: options.unitsLibrary,
                lockable
            });
        }

        return {
            type: "energycup",
            expeditions: options.expeditions,
            units
        };
    },

    BoxFamily: function (total, options) {
        const list = [
            {
                code: "sacks",
                stages: [0, 1, 2]
            },
            {
                code: "wands",
                stages: [0, 1, 2]
            },
            {
                code: "crystal",
                stages: [1, 2, 3]
            },
            {
                type: "source",
                stages: [0, 2, 4]
            },
            {
                type: "hero",
                stages: [2, 3, 4]
            },
            {
                code: "coinscup",
                stages: [0, 1, 2]
            },
            {
                type: "fruit",
                stages: [1, 2, 3]
            },
            {
                code: "energycup",
                stages: [0, 1, 2]
            },
            {
                type: "resource",
                stages: [2, 3, 4]
            },
            {
                code: "worker",
                stages: [2, 3, 4]
            },
            {
                code: "magicplant",
                stages: [2, 3, 4]
            }
        ];
        const listFixed = ["energycup", "coinscup"];

        const probabilities = cleverapps.arrayFill(list.length, 1 / list.length);

        const amount = [8, 10, 12];

        const units = [];
        for (let i = 0; i < total; i++) {
            units.push({
                price: (options && options.price) ? options.price[i] : undefined,
                cup: {
                    amount: amount[i],
                    probabilities,
                    units: list.map((unit) => ({
                        currentType: unit.type,
                        code: unit.code,
                        stage: unit.stages[i]
                    })),
                    fixed: listFixed,
                    fixedAmount: 1
                },
                shine: true
            });
        }

        return {
            type: "caravanbox",
            units
        };
    },

    TellyFamily: function (options) {
        const prizes = [{
            exp: 0,
            soft: 0
        }, {
            exp: 59,
            soft: 10
        }, {
            exp: 200,
            soft: 30
        }];

        return {
            type: "telly",
            units: prizes.map((prize) => {
                const res = {
                    telly: true,
                    shine: true
                };

                if (prize.exp || prize.soft) {
                    res.createPrize = {
                        exp: prize.exp,
                        soft: prize.soft
                    };
                }

                return res;
            }),
            expeditions: options.expeditions,
            images: options.images
        };
    },

    BarrelFamily: function () {
        return {
            type: "barrel",
            units: [
                { barrel: true, unmergeable: true, movable: false },
                { barrel: true, unmergeable: true, movable: false },
                { barrel: true, unmergeable: true, movable: false },
                { barrel: true, unmergeable: true, movable: false },
                { barrel: true, unmergeable: true, movable: false }
            ],
            localization: false
        };
    },

    IslandDecoration: function (total) {
        const units = [];

        for (let i = 0; i < total; i++) {
            units.push({
                islanddecoration: true,
                unmergeable: true,
                movable: false,
                multicellCentering: false,
                multicell: FamiliesHelper.ShapeIslandDecoration
            });
        }

        return {
            type: "islanddecoration",
            units,
            localization: false
        };
    },

    BattlePassPointsFamily: function (options) {
        const unit = {
            price: 35,
            battlepasspoints: true,
            pulsing: true,
            pointsReward: options.reward
        };

        return {
            type: "battlepasspoints",
            units: [unit],
            expeditions: options.expeditions,
            images: options.images,
            localization: false
        };
    },

    SpecialUnitFamily: function (unit, options) {
        options = options || {};

        if (!Array.isArray(unit) && options.produceOnlyWhenNeeded !== undefined) {
            unit.produceOnlyWhenNeeded = options.produceOnlyWhenNeeded;
        }

        return {
            type: options.type,
            units: Array.isArray(unit) ? unit : cleverapps.arrayFill(options.total || 1, unit),
            expeditions: options.expeditions,
            images: options.images,
            oneViewForStages: options.oneViewForStages,
            locators: options.locators,
            missionType: options.missionType,
            extraBundles: options.extraBundles,
            localization: options.localization
        };
    },

    ThirdElementUnitFamily: function (options) {
        return {
            units: [{
                unmergeable: true,
                thirdelement: true,
                selectable: false
            }, {
                unmergeable: true,
                thirdelement: true,
                selectable: false
            }],
            expeditions: options.expeditions,
            images: options.images,
            localization: false
        };
    },

    LandMarkUnitFamily: function (options) {
        const units = [];
        for (let i = 0; i < options.total; i++) {
            units.push({
                unmergeable: true,
                multicell: FamiliesHelper.ShapeSquare,
                movable: false,
                pointOfInterest: true,
                lazy: options.lazy
            });
        }
        return {
            type: options.type,
            units,
            expeditions: options && options.expeditions,
            extraBundles: options && options.extraBundles,
            images: options && options.images
        };
    },

    UnitsShopFamily: function (options) {
        options = options || {};
        if (options.tab !== undefined && options.expeditions) {
            options.tab = {};
            options.expeditions.forEach((expedition) => {
                if (ShopWindow.TABS[`UNITS_EXPEDITION_${expedition.toUpperCase()}`]) {
                    options.tab[expedition] = ShopWindow.TABS[`UNITS_EXPEDITION_${expedition.toUpperCase()}`];
                }
            });
        }
        return {
            type: "unitsshop",
            units: [{
                unmergeable: true,
                important: true,
                unitsshop: options.tab !== undefined,
                pointOfInterest: options.pointOfInterest,
                tab: options.tab,
                multicell: options.multicell
            }],
            expeditions: options.expeditions,
            images: options.images
        };
    },

    MissionWindowOpener: function (options) {
        const units = [];

        for (let i = 0; i < options.total; ++i) {
            units.push({
                movable: false,
                unmergeable: true,
                pointOfInterest: options.pointOfInterest !== undefined ? options.pointOfInterest : true,
                important: true,
                multicell: options.multicell,
                mission: options.mission
            });
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    SimpleCupFamily: function (options) {
        return {
            type: options.type,
            expeditions: options.expeditions,
            units: [{
                cup: {
                    amount: options.amount || 3,
                    probabilities: [[1]],
                    units: options.units
                }
            }],
            localization: false
        };
    },

    CollectionAnimalFamily: function (options) {
        const units = [];
        let expPrizes = [0, 1, 3, 10, 30];
        let mergeBpPoints = [0, 10, 20, 30, 40];
        if (options.type === "clpetrare") {
            expPrizes = [0, 2, 6, 20, 60, 200];
            mergeBpPoints = [0, 30, 40, 50, 60, 70, 80];
        } else if (options.type === "clpetlegend") {
            expPrizes = [0, 3, 10, 30, 100, 300, 1000];
            mergeBpPoints = [0, 50, 60, 70, 80, 90, 100];
        }

        const minFeedableStage = 2;
        const rarity = options.type.replace("clpet", "") || "regular";
        for (let i = 0; i < options.total; i++) {
            const res = {
                unmergeable: i === options.total - 1,
                mergeBpPoints: mergeBpPoints[i],
                createPrize: {
                    exp: expPrizes[i]
                },
                rarity,
                unitsLibrary: true
            };

            if (i >= minFeedableStage) {
                res.prize = {
                    resource: "pawsPoints",
                    amount: 2
                };
                res.feedable = {
                    food: { code: "clstrawberry", stage: 4 },
                    canStarve: options.type !== "clpet"
                };
            }

            units.push(res);
        }

        return {
            type: options.type,
            units,
            expeditions: ["collections"]
        };
    },

    FeedableHeroFamily: function (options) {
        const units = [];
        const expPrizes = [0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377];

        for (let i = 0; i < options.total; ++i) {
            const res = {
                heroitem: true,
                landmarkDonor: options.landmarkDonor,
                pointOfInterest: options.pointOfInterest,
                createPrize: {
                    exp: expPrizes[i]
                }
            };

            if (i === options.total - 1) {
                res.unmergeable = true;
                res.prize = {
                    resource: "wands",
                    amount: 5
                };
                res.feedable = {
                    food: options.food
                };
            }

            units.push(res);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            probability: options.probability,
            dropType: options.dropType,
            images: options.images
        };
    },

    SnailHouseFamily: function (options) {
        const probabilities = [];
        const units = [];
        const n = options.maxStage;

        for (let i = 0; i < n; i++) {
            probabilities.push(2 * (n - i) / (n * (n + 1)));
            units.push({ code: options.prize.code, stage: i });
        }

        return {
            type: "snailhouse",
            units: [{
                cup: {
                    amount: options.amount,
                    probabilities,
                    units,
                    mission: Mission.TYPE_SNAIL_FEAST
                }
            }],
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionHeroFamily: function (options) {
        const units = [];

        const expPrizes = [0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377];
        const dataByTotal = {
            default: {
                growTime: "10 minutes",
                amount: 2,
                maxGrow: 5
            },
            2: {
                growTime: "10 minutes",
                amount: 2,
                maxGrow: 5
            },
            4: {
                growTime: "20 minutes",
                amount: 2,
                maxGrow: 5
            },
            6: {
                growTime: "7 minutes",
                amount: 1,
                maxGrow: 10
            },
            7: {
                growTime: "13 minutes",
                amount: 2,
                maxGrow: 5
            },
            8: {
                growTime: "5 minutes",
                amount: 1,
                maxGrow: 10
            },
            11: {
                growTime: "3 minutes",
                amount: 2,
                maxGrow: 5
            },
            12: {
                growTime: "2 minutes",
                amount: 2,
                maxGrow: 10
            },
            pack: {
                growTime: "8 minutes",
                amount: 2,
                maxGrow: 5
            },
            ruby: {
                growTime: "4 minutes",
                amount: 1,
                maxGrow: 10
            }
        };

        const data = dataByTotal[options.tank] || dataByTotal[options.total] || dataByTotal.default;

        for (let i = 0; i < options.total; ++i) {
            const res = {
                heroitem: true,
                landmarkDonor: options.landmarkDonor,
                price: (options && options.price) ? options.price[i] : undefined,
                createPrize: {
                    exp: expPrizes[i]
                }
            };

            if (i === options.total - 1) {
                res.unmergeable = true;
                res.tank = {
                    prize: {
                        resource: "wands",
                        amount: data.amount
                    },
                    growTime: data.growTime,
                    refillPrice: 99,
                    maxGrow: data.maxGrow
                };
            }

            units.push(res);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionResourceFamily: function (options) {
        const expPrizes = [1, 2, 3, 5, 8, 13, 21, 34, 55];
        const buildable = ["0 seconds", "40 seconds", "2 minute", "15 minute", "1 hour", "2 hour", "4 hour", "8 hour", "12 hour"];
        let prizesAmount = [1, 2];
        if (options.total > 6) {
            prizesAmount = [2, 4];
        } else if (options.total > 8) {
            prizesAmount = [3, 5];
        } else if (options.total > 10) {
            prizesAmount = [4, 6];
        }

        const units = [];

        const pseudo = PseudoRandom.GET("unit");
        pseudo.seed(options.total);

        let bpPoints = options.startBpPoints;
        for (let i = 0; i < options.total; ++i) {
            const data = {
                buildable: buildable[i] || buildable[buildable.length - 1],
                bpPoints: Math.floor(bpPoints),
                createPrize: {
                    exp: expPrizes[i]
                }
            };

            bpPoints *= 1 + 3 / (i + 1);

            if (i === options.total - 1) {
                data.unmergeable = true;
                data.fruit = {
                    duration: `${pseudo.random(6, 12)}hour`,
                    exp: 10,
                    prize: [{
                        units: [{ code: options.prize, stage: 0 }],
                        amount: prizesAmount
                    }, {
                        units: [{ code: "worker", stage: 0 }],
                        amount: [0, 1]
                    }]
                };
            }

            units.push(data);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images,
            locators: options.locators
        };
    },

    ExpeditionSourceFamily: function (options) {
        let times = ["0 seconds", "0 seconds", "0 seconds", "45 seconds", "1 minute", "2 minutes", "4 minutes", "6 minutes"];
        if (["seasource", "hlsource"].indexOf(options.type) !== -1) {
            times = ["0 seconds", "0 seconds", "35 seconds", "45 seconds", "1 minute", "5 minutes"];
        }
        times.splice(2, options.skipTime);

        const units = [];

        for (let stage = 0; stage < options.mined.length; ++stage) {
            const mining = cleverapps.arrayFill(options.mined[stage]).map((value, index) => {
                let energy = 0;
                if (options.energy) {
                    energy = options.energy[index];
                }
                if (options.energyByStage) {
                    energy = options.energyByStage[stage];
                }
                return {
                    time: times[index],
                    exp: 5 * (index + 1),
                    energy
                };
            });

            units.push({
                mineable: { tasks: mining },
                unmergeable: true,
                source: true,
                price: options.price && options.price[stage]
            });
        }

        return {
            type: options.type,
            resource: options.resource,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionChestFamily: function (options) {
        return {
            type: options.type,
            resource: options.resource,
            units: FamiliesHelper.ChestFamily(options.resource, options).units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    SnailFeastFamily: function (options) {
        const expPrizes = [0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377];
        const units = [];

        for (let i = 0; i < options.total; ++i) {
            units.push({
                draggable: true,
                createPrize: {
                    exp: expPrizes[i]
                },
                info: {
                    guide: GuideWindow,
                    guideOptions: {
                        name: "RaceGuideWindow.SnailFeast",
                        bundle: bundles.snail_feast_guide_window
                    }
                }
            });
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionGrowingFamily: function (options) {
        const expPrizes = [0, 1, 2, 3];
        const mining = [
            {
                time: "1 minute",
                exp: 5,
                energy: options.energy ? options.energy[0] : 0
            }, {
                time: "2 minute",
                exp: 10,
                energy: options.energy ? options.energy[1] : 0
            }, {
                time: "3 minute",
                exp: 25,
                energy: options.energy ? options.energy[2] : 0
            }
        ];

        const units = [
            { info: true, createPrize: { exp: expPrizes[0] }, price: 0 },
            {
                mineable: { tasks: [mining[0]] }, growing: true, createPrize: { exp: expPrizes[1] }, price: 1
            },
            {
                mineable: { tasks: [mining[1]] }, growing: true, createPrize: { exp: expPrizes[2] }, price: 3
            },
            {
                mineable: { tasks: [mining[0], mining[1], mining[2]] },
                growing: true,
                createPrize: { exp: expPrizes[3] },
                price: 9
            }
        ];

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionHouseFamily: function (options) {
        const units = [];

        for (let i = 0; i < options.stages.length; ++i) {
            units.push({
                price: options.price && options.price[i],
                multicell: FamiliesHelper.ShapeSquare,
                pointOfInterest: true,
                fruit: {
                    duration: options.stages[i].timeout,
                    exp: 10,
                    prize: options.stages[i].prize
                }
            });
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ExpeditionGeneratorFamily: function (options) {
        const prize = [];
        if (options.resource) {
            prize.push({
                units: [{ code: options.resource, stage: 0 }]
            });
        }
        if (options.source) {
            prize.push({
                units: [{ code: options.source, stage: 0 }]
            });
        }
        if (options.targetType) {
            prize.push({
                units: [{ type: options.targetType, stage: 0 }]
            });
        }
        if (options.prize) {
            prize.push(
                {
                    units: [options.prize],
                    amount: options.prizeAmount || [0, 4]
                }
            );
        }

        const units = [{
            multicell: FamiliesHelper.ShapeSquare,
            important: true,
            pointOfInterest: true,
            unmergeable: true,
            fruit: {
                duration: options.duration || "5 minutes",
                exp: 10,
                prize,
                energy: options.energy
            }
        }];

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    DragoniaResourceFamily: function (options) {
        const units = [{
            unmergeable: true
        }];

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            locators: options.locators
        };
    },

    ExpeditionFieldFamily: function (options) {
        const units = [{
            field: true
        }];

        return {
            type: "field",
            units,
            expeditions: options.expeditions
        };
    },

    ExpeditionBuildingFamily: function (options) {
        const units = [{
            customer: true,
            climbable: true,
            simpleClimb: true,
            unmergeable: true,
            important: true,
            pointOfInterest: true,
            movable: false,
            stopsfog: options.stopsfog,
            hasShowUp: options.hasShowUp
        }, {
            unmergeable: true,
            customer: true,
            important: true,
            movable: false
        }];

        if (options.hasShowUpStage) {
            units.unshift({
                customer: true,
                climbable: true,
                simpleClimb: true,
                unmergeable: true,
                important: true,
                pointOfInterest: true,
                movable: false
            });
        }

        units.forEach((unit) => {
            unit.multicell = options.multicell;
            unit.campaign = options.campaign;
            unit.landmarkDonor = options.landmarkDonor;
            unit.squeezable = options.squeezable;
            unit.lazy = options.lazy;
            unit.composite = options.composite;
            unit.cookingAnimation = options.cookingAnimation;
        });

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            customTexture: options.customTexture
        };
    },

    ExpeditionCustomerFamily: function (options) {
        const units = [{
            customer: true,
            unmergeable: true,
            pointOfInterest: true,
            important: true,
            hasShowUp: options.hasShowUp
        }];

        units.forEach((unit) => {
            unit.multicell = options.multicell;
            unit.movable = options.movable;
            unit.cooldown = options.cooldown;
            unit.scrollToHead = options.scrollToHead;
            unit.lazy = options.lazy;
            unit.impassable = options.impassable;
            unit.cookingAnimation = options.cookingAnimation;
        });

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            customTexture: options.customTexture
        };
    },

    ExpeditionProductFamily: function (options) {
        const unit = {
            produceOnlyWhenNeeded: options.produceOnlyWhenNeeded
        };

        if (options.guide) {
            unit.info = {
                guide: GuideWindow,
                guideOptions: options.guide
            };
        }

        return {
            type: options.type,
            units: [unit],
            expeditions: options.expeditions,
            locators: options.locators,
            customTexture: options.customTexture
        };
    },

    RuinsFamily: function (options) {
        const units = [
            {
                price: options.price,
                unmergeable: true,
                pointOfInterest: true,
                movable: false
            }
        ];

        return {
            type: "ruins",
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    ShipFamily: function () {
        return {
            type: "ship",
            units: [
                {
                    unmergeable: true,
                    movable: false,
                    multicell: FamiliesHelper.ShapeSquare
                }
            ],
            localization: false
        };
    },

    BankFamily: function () {
        return {
            units: [
                {
                    unmergeable: true,
                    important: true,
                    pulsing: true
                }
            ],
            localization: false
        };
    },

    AdvQuestItemsFamily: function (total, options) {
        const units = [];
        for (let i = 0; i < total; i++) {
            units.push({
                unmergeable: true,
                movable: false,
                impassable: true,
                collectOnComplete: true,
                mineable: {
                    tasks: [{
                        time: "0 second",
                        energy: 0,
                        exp: 0,
                        prizes: []
                    }]
                }
            });
        }
        return {
            ...options,
            units
        };
    },

    RapunzelResourceFamily: function (options) {
        // const expPrizes = [1, 2, 3, 5, 8, 13, 21, 34, 55];
        const mergeBpPoints = options.mergeBpPoints;
        const units = [];

        for (let i = 0; i < options.total; ++i) {
            const data = {
                mergeBpPoints: mergeBpPoints && mergeBpPoints[i],
                info: options.guideOptions ? {
                    guide: GuideWindow,
                    guideOptions: options.guideOptions
                } : true
            };

            units.push(data);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            locators: options.locators,
            images: options.images
        };
    },

    RapunzelOrderFamily: function (options) {
        const energy = [0, 0, 1, 2];
        const bpPoints = [0, 0, 15, 75];
        const units = [];

        for (let i = 0; i < options.total; ++i) {
            const data = {
                bpPoints: bpPoints[i],
                info: {
                    guide: GuideWindow,
                    guideOptions: options.guideOptions || {
                        name: "rpthrone_guide_window",
                        bundle: bundles.rpthrone_guide_window
                    }
                }
            };

            if (energy[i]) {
                data.creatable = {
                    energy: energy[i]
                };
            }

            units.push(data);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    },

    RapunzelHeroFamily: function (options) {
        const energy = [0, 0, 1, 2, 5, 7, 10, 20, 25, 30];
        const bpPoints = [0, 0, 5, 15, 75, 250, 1250, 1300, 1500, 2000];
        const units = [];

        for (let i = 0; i < options.total; ++i) {
            const data = {
                landmarkDonor: options.landmarkDonor,
                heroitem: true,
                bpPoints: bpPoints[i]
            };

            if (energy[i]) {
                data.creatable = {
                    energy: energy[i]
                };
            }
            units.push(data);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            images: options.images
        };
    }
};

if (typeof cc === "undefined") {
    module.exports = FamiliesHelper;
}
